import t from "../../theme";

export const useGetNewPasswordStyles = () => {
  return {
    container: {
      width: "85%",
      maxWidth: 400,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      position: "relative",
      zIndex: 1,
    },
    heading: {
      margin: 0,
      textAlign: "left",
      color: "#ffffff",
      fontSize: "30px",
      fontWeight: 700,
      letterSpacing: "-0.2px",
      lineHeight: 1.35,
      textShadow: "0 1px 3px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.1)",
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      width: "100%",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0.3px",
    },
    submitButton: {
      borderRadius: t.radius.md,
    },
  };
};
